import styled from 'styled-components';
import { color, space, font, fontStack, query } from '@design/templateFns';

import { Button } from '@components/Button';

export const GroupPageHeadline = styled.h2`
  ${font('headline-md')};
  padding-bottom: 0;
  text-align: left;

  @media screen and (${query.below('tablet')}) {
    ${font('headline-xs')};
  }
`;

//GroupPage Odd Number Card
export const OddNumberCardWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 0;
  padding-bottom: 75%; // to mimic 4:3 aspect ratio of the images
`;

export const OddNumberCardInner = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: ${color('secondaryBg')};
  padding: ${space('lg')};
  box-sizing: border-box;
  transition: color 0.2s ease-in-out;

  &:hover {
    color: ${color('gray5')};
  }

  a::after {
    box-sizing: border-box;
    display: block;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1;
    content: '';
  }
`;

export const OddNumberCardHeadline = styled.div`
  display: flex;
  ${font('headline-xs')};
  text-align: center;
  margin-bottom: ${space('md')};
`;
